import { useEffect } from "react";
import HoumaHeroSection from "./components/HeroSection";
import HoumaStickyNav from "./components/StickyNav";
import HoumaProcessingTimeSection from "./components/ProcessingTimeSection";
import HoumaServicesSection from "./components/ServicesSection";
import HoumaLocalAreaSection from "./components/LocalAreaSection";
import HoumaTestimonialsSection from "./components/TestimonialsSection";
import HoumaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HoumaComparisonSection from "./components/ComparisonSection";
import HoumaMistakesSection from "./components/MistakesSection";
import HoumaHowItWorksSection from "./components/HowItWorksSection";
import HoumaFAQSection, { faqs } from "./components/FAQSection";
import HoumaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HoumaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import HoumaTravelTimingSection from "./components/TravelTimingSection";
import HoumaDestinationsSection from "./components/DestinationsSection";

export default function HoumaPage() {
  useEffect(() => {
    document.title = "Emergency Passport Houma, LA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/houma/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Houma, LA — as fast as 24 hours. Serving offshore workers, fishing industry travelers, and families in Terrebonne Parish. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Houma, Louisiana");
    setMeta("geo.region", "US-LA");
    setMeta("geo.position", "29.5958;-90.7195");
    setMeta("ICBM", "29.5958, -90.7195");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Louisiana", item: "https://fastpassportcenter.com/louisiana/" },
          { "@type": "ListItem", position: 3, name: "Houma Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Houma and the bayou region. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Houma", containedInPlace: { "@type": "State", name: "Louisiana" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-houma";
    document.getElementById("structured-data-houma")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-houma")?.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <HoumaHeroSection />
      <HoumaStickyNav />
      <HoumaProcessingTimeSection />
      <HoumaServicesSection />
      <HoumaLocalAreaSection />
      <HoumaTravelTimingSection />
      <HoumaDestinationsSection />
      <HoumaTestimonialsSection />
      <HoumaAcceptanceFacilitiesSection />
      <HoumaComparisonSection />
      <HoumaMistakesSection />
      <HoumaHowItWorksSection />
      <HoumaFAQSection />
      <HoumaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/houma" state="LA" />
      <HoumaFinalCTA />
    </div>
  );
}